export default {
  items: function items(state) {
    return state.items;
  },
  products: function products(state) {
    return state.products;
  }
};